export default __webpack_public_path__ + "static/media/480_business01-it-web.80b20f6f.png";